import { COMMUNITY_URL } from '@/config/index.ts';
import { StyledFooter } from './Footer.styled.tsx';

import Logo from '/images/admitone.svg';

const Footer = () => {
    return (
        <StyledFooter>
            <div className="fc_inner_container">
                <div className="fc_section">
                    <a className="fc_logo">
                        <img
                            src={Logo}
                            alt="Powered by AdmitONE"
                            style={{ width: '100%', maxWidth: '150px' }}
                        />
                    </a>
                </div>
                <ul className="fc_ul">
                    <li>
                        <a
                            className="fc_ul_link"
                            href={`${COMMUNITY_URL}privacy-policy`}
                            target="_blank"
                        >
                            Privacy Policy
                        </a>
                    </li>
                    <li>
                        <a
                            className="fc_ul_link"
                            href={`${COMMUNITY_URL}community/terms-of-service`}
                            target="_blank"
                        >
                            Terms of Services
                        </a>
                    </li>
                    <li>
                        <a
                            className="fc_ul_link"
                            href={`${COMMUNITY_URL}contact/community/customer-support`}
                            target="_blank"
                        >
                            Contact us
                        </a>
                    </li>
                </ul>
            </div>
        </StyledFooter>
    );
};

export default Footer;
